import http from 'plugins/axios';

export default {
  getMessageTemplates(data) {
    return http.get({
      url: '/admin/sms/search',
      data
    });
  },
  createMessageTemplate(data) {
    return http.post({
      url: '/admin/sms/add',
      data
    });
  },
  updateMessageTemplate(data) {
    return http.post({
      url: '/admin/sms/update',
      data
    });
  },
  sendMessage(data) {
    return http.post({
      url: '/admin/sms/add/sendUser',
      data
    });
  }
};
